import { BoxTable } from '@/box/table'
import { BoxToolbar } from '@/box/toolbar'
import { Column } from '@/shared/Column'
import React from 'react'
import { TemplateApplyProps } from '../interface'

export const TemplateApply: React.FC<TemplateApplyProps> = (
  props: TemplateApplyProps
) => {
  const columns: Column[] = [
    { index: 4, hidden: true }, // 隐藏下发状态列
    { index: 6, hidden: true }, // 隐藏关联模板列
    { index: 7, hidden: true }, // 隐藏设备数量列
    { index: 8, hidden: true }, // 隐藏变量数量列
    { index: 9, hidden: true }, // 隐藏联网方式列
    { index: 10, hidden: true },// 隐藏离线时间列
    { index: 11, hidden: true } // 隐藏操作列
  ]

  return (
    <div>
      <BoxToolbar
        showConnectionStates={false}
        showTemplateStates={false}
        showRemark={false}
        showFilter={false}
        showImport={false}
        showOperations={false}
        onSearch={props.onSearch}
      />
      <BoxTable
        data={props.data}
        columns={columns}
        selectable={true}
        selectionType='checkbox'
        onSelect={props.onSelect}
        pagination={props.pagination}
      />
    </div>
  )
}
